var __jsx = React.createElement;
import { Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import TabPanel from 'components/common/TabPanel';
import FormBuilder from 'components/content/FormBuilder';
import GroupField from 'components/content/GroupField';
import { FormHeader } from './ContentForm.style';

var ContentForm = function ContentForm(_ref) {
  var contentType = _ref.contentType;

  var _useState = useState(0),
      tabIndex = _useState[0],
      setTabIndex = _useState[1];

  var handleChangeTab = function handleChangeTab(event, newTabIndex) {
    setTabIndex(newTabIndex);
  };

  return __jsx(React.Fragment, null, __jsx(FormHeader, null, __jsx(Tabs, {
    value: tabIndex,
    onChange: handleChangeTab
  }, contentType.fields.map(function (groupField) {
    return __jsx(GroupField, {
      key: "group-".concat(groupField.name),
      group: groupField,
      groupLevel: 0
    });
  }))), contentType.fields.map(function (groupField, index) {
    return __jsx(TabPanel, {
      key: "tabpanel-".concat(groupField.name),
      value: tabIndex,
      index: index
    }, __jsx(FormBuilder, {
      formFields: groupField.fields,
      groupLevel: 0
    }));
  }));
};

export default ContentForm;